<template>
  <div>
    <p v-for="line in storyLine.lines" :key="line.index" class="story-text-style">{{ line }}</p>

    <section v-if="userChoice[6] == 'sorrow'" class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>

    <section v-if="userChoice[6] == 'goal'" class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>
  </div>
</template>

<script>
export default {
  name: "Story-Eight",
  data() {
    return {
      userTrait: this.$store.state.userPersonality,
      userChoice: this.$store.state.userChoices
    };
  },
  computed: {
    storyLine() {
      return this.$store.state.Eight[this.userChoice[6]];
    }
  },
  methods: {
    navigateEnd(condition) {
      if (condition) {
        this.$router.push("/story/end");
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/css/Scheme.scss";
</style>
